import Splide from '@splidejs/splide';

const initSingleProductRelated = (section) => {
  if (section.dataset.singleProductRelatedReady === 'true') return;

  const sliderElement = section.querySelector(
    '.single-product-related__slider'
  );
  const progressBar = section.querySelector('[data-related-products-progress]');
  const slideCount =
    sliderElement?.querySelectorAll('.splide__slide').length || 0;

  if (!sliderElement || !slideCount) return;

  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;
  const slider = new Splide(sliderElement, {
    arrows: false,
    autoWidth: true,
    drag: slideCount > 1 ? 'free' : false,
    gap: '28px',
    pagination: false,
    snap: true,
    speed: reducedMotion ? 0 : 650,
    type: slideCount > 1 ? 'loop' : 'slide',
  });

  const updateProgress = () => {
    if (!progressBar) return;

    const end = Math.max(0, slider.Components.Controller.getEnd());
    const progress = end ? Math.min(slider.index / end, 1) : 0;
    const thumbWidth = 100 / Math.max(1, end + 1);

    progressBar.style.width = `${thumbWidth}%`;
    progressBar.style.left = `${progress * (100 - thumbWidth)}%`;
  };

  slider.on('mounted moved dragged scrolled resized', updateProgress);
  slider.mount();

  section.dataset.singleProductRelatedReady = 'true';
};

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-single-product-related]')
    .forEach(initSingleProductRelated);
});
